<script>
  import {onMount} from "svelte";
  import VisualMedia from "../Elemental Components/VisualMedia.svelte";
  import {WaitlistViewModel, applyToWaitlist} from "../AppState/EndpointsAndTransforms";

  onMount(() => window.scrollTo(0, 0));

  let username;
  let email;
  let petName;
  let petImage;

  let files;
  $: filestring = "empty"
  $: { if (files) {
    const reader = new FileReader()
      reader.readAsDataURL(files[0])
      reader.onload = function(evt) {
        filestring = evt.target.result
      }
  }}

  function handleSubmit() {
    applyToWaitlist(username, email, petName, filestring, render)
  }

  let viewState = WaitlistViewModel.initial
  let viewStateAssociatedData = {
    petName: "default name",
    email: "default@placeholder.com",
    petURL: "fake.com/image",
  }

  function render(data, state) {
    viewStateAssociatedData = data
    viewState = state
  }
</script>

<main>
  <h2>Be some of the first paws featured here.</h2>
  <row>
    <picture>
      <VisualMedia image="/images/air_conditioning.jpg"/>
    </picture>
    <h3>We're just getting started...</h3>
  </row>
  <p>As an early member of the community, you can help us show the world that social media can be different. Uplifting, positive, joyful, and a source of connection across humanity through our shared love of animals.</p>
  <p>Tell your pet's stories, and help set the tone for the future.</p>
  <p>Priority will always be given to early community members' public stories on the 'featured' timeline, as a way of saying "thanks for helping us get started!"</p>
  <dividerLine/>

  { #if viewState === WaitlistViewModel.initial}
  <p>We're not accepting everyone yet, but are trying to find an elite early group of animals and their human story-tellers who can set the pace for the future community.</p>
  <p><i>If you'd like to be a part of it, get on the waitlist here:<i/></p>

  <form on:submit|preventDefault={handleSubmit}>
    <row>
      <p>Your Name</p>
      <input bind:value={username}>
    </row>
    <row>
      <p>Email Address</p>
      <input bind:value={email}>
    </row>
    <row>
      <p>Your Pet's Name</p>
      <input bind:value={petName}>
    </row>
    <row>
      <p>Photo of your pet</p>
      <input
        accept="image/png, image/jpeg, image/jpg"
        bind:files
        id="avatar"
        name="avatar"
        type="file"
      />
      <button type="submit">Submit</button>
    </row>
    <p>2Mb or smaller .jpg or .png please!</p>
  </form>


  {:else if viewState === WaitlistViewModel.loading}
    <h1>Processing your application right now...</h1>
    <p>image of cody waiting and some text</p>

  {:else if viewState === WaitlistViewModel.success}
    <h1>Great news, {viewStateAssociatedData.petName} is on the list!</h1>
    <p>We'll e-mail to follow up with you at {viewStateAssociatedData.email} and let you know when you're able to create an account.</p>
    <row>
      <picture>
        <img src={viewStateAssociatedData.petURL}>
      </picture>
      <h3>Get ready to tell my story!!</h3>
    </row>

  {:else if viewState === WaitlistViewModel.duplicate_entry}
    <h1>Hmmm, So it looks like you're already on the waitlist...</h1>
    <row>
      <picture>
        <img src={viewStateAssociatedData.petURL}>
      </picture>
      <p>Is this {viewStateAssociatedData.petName}?</p>
    </row>
    <p>Someone already registered {viewStateAssociatedData.email} as the e-mail address for {viewStateAssociatedData.petName}</p>
    <p>If that was you, and that information is correct, then you're all set on the waitlist!</p>
    <p>If you think something has gone wrong, send a quick e-mail to ryan@lookatthesepaws.com to let me know what happened.</p>

    <p>or you can:</p>
    <button
    on:click="{ () => {
      viewState = WaitlistViewModel.initial
     }
    }">Reset waitlist form</button>

  {:else if viewState === WaitlistViewModel.error}
    <h2>Something went wrong adding you to the waitlist automatically.</h2>
    <p>Would you mind sending a quick e-mail to ryan@lookatthesepaws.com with your pet's name and attach a photo of them?</p>
    <p>I'll add you to the waitlist manually...</p>

    <p>or you can:</p>
    <button
      on:click="{ () => {
      viewState = WaitlistViewModel.initial
     }
    }">Reset waitlist form and try again</button>

  {/if}
</main>

<style>
  main {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  picture {
    display: block;
    align-items: center;
    max-width: 500px;
    margin: 3px 3px 3px 3px;
    height: auto;
    float: left;
  }

  img {
    border-radius: 7px;
    box-shadow: 0 10px 7px -3px #272d35;
    width: 100%;
    max-width: 150%;
    max-height: 750px;
    height: auto;
  }

  row {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
    align-content: space-around;
    padding: 7px 30px 7px 10px;
    margin-bottom: 12px;
  }

  dividerLine {
    background-color: rgba(107,118,141,0.3);
    width: 80%;
    height: 1px;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  p {
    margin-left: 20px;
    margin-right: 20px;
  }

  input {
    margin-left: 10px;
  }

  h3 {
    margin-left: 8px;
  }
</style>